<template>
  <el-main>
    <h1 style="text-align: left">ユーザー設定</h1>
    <el-row>
      <el-col :span="spanItems">
        <input-number v-model="exchange.dollar" v-bind:label="'ドル'" v-bind:suffix="'円'"
                      v-bind:spanTitle="spanTitleSide"
                      v-bind:spanSetting="spanSettingSide"
                      v-bind:spanSuffix="spanSuffix"
                      v-on:commit="updateExchangeDollar($event)">
        </input-number>
      </el-col>
      <el-col :span="spanItems">
        <input-number v-model="exchange.euro" v-bind:label="'ユーロ'" v-bind:suffix="'円'"
                      v-bind:spanTitle="spanTitleSide"
                      v-bind:spanSetting="spanSettingSide"
                      v-bind:spanSuffix="spanSuffix"
                      v-on:commit="updateExchangeEuro($event)">
        </input-number>
      </el-col>
      <el-col :span="spanItems">
        <input-number v-model="exchange.pound" v-bind:label="'ポンド'" v-bind:suffix="'円'"
                      v-bind:spanTitle="spanTitleSide"
                      v-bind:spanSetting="spanSettingSide"
                      v-bind:spanSuffix="spanSuffix"
                      v-on:commit="updateExchangePound($event)">
        </input-number>
      </el-col>
      <el-col :span="spanItems">
        <input-number v-model="charge" v-bind:label="'バイマ手数料'" v-bind:suffix="'％'"
                      v-bind:spanTitle="spanTitleSide"
                      v-bind:spanSetting="spanSettingSide"
                      v-bind:spanSuffix="spanSuffix"
                      v-on:commit="updateCharge($event)">
        </input-number>
      </el-col>
    </el-row>
    <h1 style="text-align: left">配送方法</h1>
    <el-table :data="Object.values(deliveryMethods)">
      <el-table-column label="ID" width="100" prop="id">
      </el-table-column>
      <el-table-column label="表示名" width="400" prop="explains">
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button size="mini"
                      icon="el-icon-delete"
                      @click="removeDeliveryMethod(scope.row.id)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-button type="text" @click="openDialog()">配送方法追加</el-button>
    </el-row>
    <el-dialog title="配送方法追加"
                width="40%"
                :visible.sync="dialogVisible"
                v-on:closed="$emit('update:dialogVisible', false)">
      <el-row>
        <el-col :span="4">
          <span>ID</span>
        </el-col>
        <el-col :span="11">
          <el-input type="text" v-model="dlgTextId" required minlength="6" maxlength="6" show-word-limit></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <span>表示名</span>
        </el-col>
        <el-col :span="11">
          <el-input type="text" v-model="dlgTextName" required maxlength="100" show-word-limit></el-input>
        </el-col>
      </el-row>
      <p v-for="msg in errMsgs" :key="msg" style="color:red">
        {{msg}}
      </p>
      <el-row>
        <el-button @click="addDeliveryMethod()">追加</el-button>
        <el-button @click="dialogVisible=false">キャンセル</el-button>
      </el-row>
    </el-dialog>
  </el-main>
</template>

<script>
import InputNumber from '@/components/InputNumber.vue'
import api from '@/http/api.js'

export default {
  name: 'UserConf',
  components: {
    inputNumber: InputNumber
  },
  data: function () {
    return {
      spanItems: 5,
      spanTitleSide: 12,
      spanSettingSide: 7,
      spanSuffix: 4,
      exchange: {
        dollar: 100,
        euro: 100,
        pound: 100
      },
      charge: 7,
      deliveryMethods: {},
      dialogVisible: false,
      dlgTextId: '',
      dlgTextName: '',
      errMsgs: []
    }
  },
  methods: {
    updateExchangeDollar: function (value) {
      api.userconfig.setConfiguration({
        key: 'DOLLAR',
        value: String(value)
      })
    },
    updateExchangeEuro: function (value) {
      api.userconfig.setConfiguration({
        key: 'EURO',
        value: String(value)
      })
    },
    updateExchangePound: function (value) {
      api.userconfig.setConfiguration({
        key: 'POUND',
        value: String(value)
      })
    },
    updateCharge: function (value) {
      api.userconfig.setConfiguration({
        key: 'CHARGE',
        value: String(value)
      })
    },
    addDeliveryMethod: async function () {
      this.errMsgs = []
      if (this.deliveryMethods[this.dlgTextId] != null) {
        this.errMsgs.push('IDが重複しています')
      }
      var RE = /[0-9]{6}/
      if (!RE.test(this.dlgTextId)) {
        this.errMsgs.push('IDは6桁の数字で入力する必要があります')
      }
      if (this.dlgTextName == null || this.dlgTextName === '') {
        this.errMsgs.push('表示名が入力されていません')
      }
      if (this.errMsgs.length <= 0) {
        await api.delivery.insertDeliveryMethods({
          id: this.dlgTextId,
          explains: this.dlgTextName
        })
        this.deliveryMethods = await api.delivery.getDeliveryMethods()
        this.dialogVisible = false
      }
    },
    removeDeliveryMethod: async function (id) {
      await api.delivery.deleteDeliveryMethods(id)
      this.deliveryMethods = await api.delivery.getDeliveryMethods()
    },
    openDialog: function () {
      this.dlgTextId = ''
      this.dlgTextName = ''
      this.dialogVisible = true
    }
  },
  created: async function () {
    this.exchange.dollar = Number(await api.userconfig.getConfiguration('DOLLAR'))
    this.exchange.euro = Number(await api.userconfig.getConfiguration('EURO'))
    this.exchange.pound = Number(await api.userconfig.getConfiguration('POUND'))
    this.charge = Number(await api.userconfig.getConfiguration('CHARGE'))
    this.deliveryMethods = await api.delivery.getDeliveryMethods()
  }
}
</script>

<style scoped>
.el-container {
  margin: 0 auto 0;
  width: 75%;
}
.el-row {
  margin-bottom: 10px;
}
</style>
